import Modal from "react-bootstrap/Modal";
import FieldDrop from "./FieldDrop";
import close from "../../../images/close-Icon-black.svg";
import "../../../styles/FieldDrop.css";

/**
 * FieldDropPopup displays the FieldDrop carousel/page in a modal dialog.
 *
 * @param {boolean} show - Whether the modal is visible
 * @param {function} onHide - Callback to close the modal
 * @param {Array} data - Array of child card data for FieldDrop
 * @param {function} onNavigate - Callback for navigation from FieldDrop
 */
const FieldDropPopup = ({ show, onHide, data, onNavigate, sponsorName }) => {
  const fieldDropData = data.map(card => ({...card, sponsorName }));
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}
      className="fieldDropPopup"
    >
      <Modal.Body>
        {/* Close button in the top right corner */}
        <button className="AddChildCloseIcon" onClick={onHide}>
          <img src={close} alt="close" />
        </button>
        {/* Main FieldDrop content */}
        <FieldDrop data={fieldDropData} onNavigate={onNavigate} />
      </Modal.Body>
    </Modal>
  );
};

export default FieldDropPopup;